
import * as types from '@/store/mutation-types';
import auth from '@/lib/auth';
import { postApi } from '../comm/middleware/callApi';
import apis from '../comm/api/apis';
import reportLog from '../comm/middleware/reportLog';

// 换取签名
export const healthSign = ({ state, commit }, { userType = 'expert', token }) => {
  console.log('用户信息');
  console.log(userType === 'expert' ? state.expertInfo : state.userInfo);
  if (!token) {
    token = userType === 'expert' ? state.expertInfo.token : state.userInfo.token;
  }
  const param = JSON.stringify({
    oem: window.navigator.userAgent,
    osversion: '9.0',
    screenwidth: window.screen.width,
    screenheight: window.screen.height,
    apptype: '1',
    appversion: '2.0.0',
    nettype: 'unknown',
    regcode: '250',
    provcode: '264',
    partner: 'babytree',
    isHttps: document.location.protocol === 'https:' ? '1' : '0',
    token
  });
  postApi({ commit }, apis.healthSign, param).then((body) => {
    if (body && body.rescode && body.rescode.code === '-100') {
      auth.clear();
      auth.login(userType);
    }
    commit(types.AJAX_GET_SIGNDATA, { signData: body });
  }).catch((err) => {
    const msg = {
      name: '大健康签名失败',
      protocol: document.location.protocol === 'https:' ? 'https' : 'http',
      info: err,
      time: Date.parse(new Date()),
      user: userType === 'expert' ? state.expertInfo : state.userInfo,
      url: location.href
    };
    if (err.message === 'SERVER_ERROR') {
      auth.clear();
      auth.login(userType, null);
    }
    reportLog(msg).then(() => {
      console.log('日志-大健康签名失败');
    });
  });
};

export const noop = () => {};



// WEBPACK FOOTER //
// ./src/store/action.util.js